// extracted by mini-css-extract-plugin
export var active = "_js-e";
export var blink = "_js-f";
export var dropDownSelector = "_js-5";
export var dropDownWrapper = "_js-4";
export var fakeCursor = "_js-d";
export var fontSizeButton = "_js-7";
export var formQuillEditor = "_js-0";
export var pressed = "_js-g";
export var qlBlank = "_js-1";
export var textFormattingToolbar = "_js-2";
export var textFormattingToolbarClosed = "_js-3";
export var textFormattingToolbarInline = "_js-6";
export var textToolbarOption = "_js-8";
export var toolbarCell = "_js-a";
export var toolbarCellCollapsed = "_js-b";
export var toolbarOptionHitArea = "_js-c";
export var toolbarOverflow = "_js-9";